import { render } from "./ProjectsComponent.vue?vue&type=template&id=4ae3c110&scoped=true"
import script from "./ProjectsComponent.vue?vue&type=script&lang=js"
export * from "./ProjectsComponent.vue?vue&type=script&lang=js"

import "./ProjectsComponent.vue?vue&type=style&index=0&id=4ae3c110&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae3c110"]])

export default __exports__